import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { OverlayPanel } from 'primeng/overlaypanel';
import { forkJoin, Subscription } from 'rxjs';
import {
  CodeType,
  codeTypes,
  MultiData,
  options,
  TikZType
} from 'src/app/constants/constants';
import { GlobalApiService } from 'src/app/services/global-api.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import {
  QuestionBankFilter,
  QuestionBankService
} from '../question-bank/question-bank.service';
import { ConfirmationService } from 'primeng/api';
import {
  Course,
  questionCategories,
  QuestionVideo
} from './create-question.constant';
import { DomSanitizer } from '@angular/platform-browser';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

declare var update: any;
@Component({
  selector: 'app-create-question',
  templateUrl: './create-question.component.html',
  styleUrls: ['./create-question.component.scss']
})
export class CreateQuestionComponent implements OnInit, OnDestroy {
  optionsText: string[] = options;
  showQuestions: boolean = true;
  selectedTab: number = 1;
  showOptions: boolean = false;
  questionArray: MultiData[] = [];
  optionArray: MultiData[][] = [[], [], [], []];
  optionExplanations: MultiData[][] = [[], [], [], []];
  selectedOption: number | null = 0;
  questionText: string = '';
  codeTypes: CodeType[] = codeTypes;
  paramSubscription: Subscription;
  topics: any[] = [];
  selectedTopic: number | null = null;
  selectedSubTopic: number | null = null;
  subTopics: any[] = [];
  // selectedLevel: number | null = null;
  difficultyLevels: any[] = [];
  notifier: NotifierService;
  selectedQuestionType: number | null = 1;
  tikzExists: boolean = false;
  selectedDisplayStyle: number = 1;
  defaultAnswer: number | null = null;
  gridinAnswers: { data: string; hidden?: boolean }[] = [
    { data: '', hidden: false }
  ];
  saveQuestionClicked: boolean = false;
  errorExists: boolean = false;
  questionError: boolean = false;
  optionsError: boolean = false;
  gridinError: boolean = false;
  gridinExplanations: MultiData[] = [];
  panelType: string = '';
  tags: any[] = [];
  isTestQuestion: boolean = true;
  // Screen to go back to after saving; only known screens are allowed.
  returnTo: string = '/question-bank';
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  questionDetails: any = [];
  questionId: number | null = null;
  questionBankFilterSubscription: Subscription;
  questionBankFilter: QuestionBankFilter | undefined;
  isCreateQuestion: boolean = true;
  status: number = 1;
  deleteInfo: { index: number; type: string; imageIndex: number } | null = null;
  courses: any[] = [];
  selectedCourses: Course[] = [];
  attachedToError: boolean = false;
  images: any = {};
  questionCategories = questionCategories;
  selectedVideos: File[] = [];
  questionVideos: QuestionVideo[] = [];
  selectedVideoUrl: any = null;
  uploadProgress = 0;
  isUploading = false;
  selectedVideoIndex: number | null = null;
  constructor(
    private route: ActivatedRoute,
    private globalApiService: GlobalApiService,
    private router: Router,
    notifierService: NotifierService,
    private questionBankService: QuestionBankService,
    private confirmationService: ConfirmationService,
    private sanitizer: DomSanitizer
  ) {
    this.notifier = notifierService;
    this.isCreateQuestion =
      window.location.hash.startsWith('#/create-question');
    this.paramSubscription = this.route.queryParams.subscribe(
      (params: Params) => {
        const questionId: number = parseInt(params['question_id']);
        this.questionId = isNaN(questionId) ? null : questionId;
        this.returnTo =
          params['returnTo'] === '/question-bank-ai'
            ? '/question-bank-ai'
            : '/question-bank';
      }
    );
    this.questionBankFilterSubscription = this.questionBankService
      .getQuestionBankFilters()
      .subscribe((filter: QuestionBankFilter) => {
        this.questionBankFilter = filter;
        console.log('create or edit', this.questionBankFilter);
      });
  }

  ngOnInit() {
    this.getData();
    this.codeTypes = this.codeTypes.filter(
      (codeType) => codeType.type !== 'Empty'
    );
    if (this.isCreateQuestion && this.questionBankFilter?.courseId) {
      this.selectedCourses.push({
        courseId: this.questionBankFilter.courseId,
        sectionId: this.questionBankFilter.sectionId || null,
        topicId: this.questionBankFilter.topicId || null,
        subTopicId: this.questionBankFilter.subTopicId || null,
        difficultyLevel: this.questionBankFilter.difficultyLevel || null,
        questionCategory: 'TEST_QUESTION',
        hidden: false,
        sections: [],
        topics: [],
        subTopics: []
      });
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (this.questionId) {
      this.getQuestionVideos();
    }
  }

  /* Adding Question, option and gridin answers */

  addMultiData(codeType: string, overlayPanel: OverlayPanel): void {
    switch (this.panelType) {
      case 'question':
        this.questionArray.push({
          type: codeType,
          data: '',
          hidden: false,
          images: []
        });
        this.questionArray.forEach((question, index) => {
          question.hidden = index !== this.questionArray.length - 1;
        });
        break;
      case 'option':
        this.optionArray[this.selectedOption!].push({
          type: codeType,
          data: '',
          hidden: false,
          images: []
        });
        this.optionArray[this.selectedOption!].forEach((option, index) => {
          option.hidden =
            index !== this.optionArray[this.selectedOption!].length - 1;
        });
        break;
      case 'optionExplanation':
        this.optionExplanations[this.selectedOption!].push({
          type: codeType,
          data: '',
          hidden: false,
          images: []
        });
        this.optionExplanations[this.selectedOption!].forEach(
          (optionExplanation, index) => {
            optionExplanation.hidden =
              index !==
              this.optionExplanations[this.selectedOption!].length - 1;
          }
        );
        break;
      case 'gridinExplanation':
        this.gridinExplanations.push({
          type: codeType,
          data: '',
          hidden: false,
          images: []
        });
        this.gridinExplanations.forEach((gridinExplanation, index) => {
          gridinExplanation.hidden =
            index !== this.gridinExplanations.length - 1;
        });
        break;
      default:
        break;
    }
    console.log(this.optionExplanations);
    overlayPanel.hide();
    this.doesTikzExists();
    setTimeout(() => {
      switch (this.panelType) {
        case 'question':
          document
            .getElementById(`question-${this.questionArray.length - 1}`)
            ?.focus();
          break;
        case 'option':
          document
            .getElementById(
              `option-${this.selectedOption}-${
                this.optionArray[this.selectedOption!].length - 1
              }`
            )
            ?.focus();
          break;
        case 'optionExplanation':
          document
            .getElementById(
              `optionExplanation-${this.selectedOption}-${
                this.optionExplanations[this.selectedOption!].length - 1
              }`
            )
            ?.focus();
          break;
        case 'gridinExplanation':
          document
            .getElementById(
              `gridinExplanation-${this.gridinExplanations.length - 1}`
            )
            ?.focus();
          break;
        default:
          break;
      }
    }, 100);
  }

  addOption(): void {
    this.optionArray.push([]);
    this.optionExplanations.push([]);
  }

  addGridin(): void {
    this.gridinAnswers.push({ data: '', hidden: false });
    this.gridinAnswers.forEach((answer, index) => {
      answer.hidden = index !== this.gridinAnswers.length - 1;
    });
    setTimeout(() => {
      document
        .getElementById(`answer-${this.gridinAnswers.length - 1}`)
        ?.focus();
    }, 100);
  }

  addTag(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our tag
    if ((value || '').trim()) {
      this.tags.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  addCourses() {
    this.selectedCourses.push({
      courseId: null,
      sectionId: null,
      topicId: null,
      subTopicId: null,
      difficultyLevel: null,
      questionCategory: 'TEST_QUESTION',
      hidden: false,
      sections: [],
      topics: [],
      subTopics: [],
      videos: []
    });
    this.selectedCourses.forEach((course: Course, index) => {
      course.hidden = index !== this.selectedCourses.length - 1;
    });
  }

  /* Handling the overlay of adding code */
  toggleOverlay(overlayPanel: OverlayPanel, event: any, panelType: string) {
    this.panelType = panelType;
    overlayPanel.toggle(event);
  }

  toggleAccordion(toggleIndex: number, array: any[]) {
    console.log(toggleIndex, array);
    array.forEach((item, index) => {
      if (index === toggleIndex) {
        item.hidden = !item.hidden;
      } else {
        item.hidden = true;
      }
    });
  }

  /* Removing the question, option and Gridin Answers */

  removeMultiData(index: number, type: string, imageIndex: number): void {
    switch (type) {
      case 'question':
        if (imageIndex < 0) {
          this.questionArray.splice(index, 1);
        } else {
          this.questionArray[index].images.splice(imageIndex, 1);
        }
        break;
      case 'option':
        if (imageIndex < 0) {
          this.optionArray[this.selectedOption!].splice(index, 1);
        } else {
          this.optionArray[this.selectedOption!][index].images.splice(
            imageIndex,
            1
          );
        }
        break;
      case 'optionExplanation':
        if (imageIndex < 0) {
          this.optionExplanations[this.selectedOption!].splice(index, 1);
        } else {
          this.optionExplanations[this.selectedOption!][index].images.splice(
            imageIndex,
            1
          );
        }
        break;
      case 'gridinExplanation':
        if (imageIndex < 0) {
          this.gridinExplanations.splice(index, 1);
        } else {
          this.gridinExplanations[index].images.splice(imageIndex, 1);
        }
        break;
      case 'course':
        this.selectedCourses.splice(index, 1);
        break;
      default:
        break;
    }
    this.doesTikzExists();
  }

  removeOption(index: number): void {
    this.optionArray.splice(index, 1);
    this.optionExplanations.splice(index, 1);
    if (this.defaultAnswer === index + 1) {
      this.defaultAnswer = null;
    }
    if (this.selectedOption === index) {
      this.selectedOption = 0;
    }
  }

  removeGridin(gridinIndex: number): void {
    this.gridinAnswers.splice(gridinIndex, 1);
  }

  removeTag(index: number): void {
    this.tags.splice(index, 1);
  }

  confirmDelete(index: number, type: string, imageIndex: number): void {
    this.deleteInfo = { index, type, imageIndex };
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete?',
      header: 'Confirmation',
      accept: () => {
        if (type === 'gridin') {
          this.removeGridin(index);
        } else {
          this.removeMultiData(index, type, imageIndex);
        }
        this.deleteInfo = null;
      },
      reject: () => {
        this.deleteInfo = null;
      }
    });
  }

  /* On Course Selection */
  selectCourse(index: number): void {
    this.selectedCourses[index].sectionId = null;
    this.selectedCourses[index].topicId = null;
    this.selectedCourses[index].subTopicId = null;
    this.selectedCourses[index].sections = [];
    this.selectedCourses[index].topics = [];
    this.selectedCourses[index].subTopics = [];
    this.getSectionsForCourse(index);
  }

  /* On Section Selection */
  selectSection(index: number): void {
    this.selectedCourses[index].topicId = null;
    this.selectedCourses[index].subTopicId = null;
    this.selectedCourses[index].topics = [];
    this.selectedCourses[index].subTopics = [];
    this.getTopicsAndSubTopics(index);
  }

  /* On topic selection */
  selectTopic(index: number) {
    const course: Course = this.selectedCourses[index];
    course.subTopicId = null;
    const topicIndex = course.topics.findIndex((topic: any) => {
      return topic.topic_id === course.topicId;
    });
    console.log(topicIndex);
    course.subTopics = course.topics[topicIndex].subtopics;
  }

  /* TikZ related code */

  doesTikzExists(): void {
    let tikzExists = false;
    for (let i = 0; i < this.questionArray.length; i++) {
      const question = this.questionArray[i];
      if (question.type === 'TikZ') {
        tikzExists = true;
        break;
      }
    }
    if (!tikzExists) {
      for (let i = 0; i < this.optionArray.length; i++) {
        const option = this.optionArray[i];
        for (let j = 0; j < option.length; j++) {
          const optionItem = option[j];
          if (optionItem.type === 'TikZ') {
            tikzExists = true;
            break;
          }
        }
      }
    }
    this.tikzExists = tikzExists;
  }

  loadTikZ() {
    console.log(this.optionExplanations);
    const totaltikZ: TikZType[] = [];
    for (let i = 0; i < this.questionArray.length; i++) {
      const question = this.questionArray[i];
      if (question.type === 'TikZ') {
        totaltikZ.push({
          id: 'tikzOutput' + i,
          data: question.data
        });
      }
    }
    console.log(totaltikZ);
    for (let i = 0; i < this.optionArray.length; i++) {
      const option = this.optionArray[i];
      for (let j = 0; j < option.length; j++) {
        const optionItem = option[j];
        if (optionItem.type === 'TikZ') {
          totaltikZ.push({
            id: 'tikzOutput-option-' + i + '-' + j,
            data: optionItem.data
          });
        }
      }
      console.log(option);
    }
    // ** LOad tikz for Explanations
    const explanations: any[] = this.optionExplanations || [];
    console.log(explanations);
    explanations.forEach((explanation, explanationIndex) => {
      explanation.forEach((explanationItem: any, explanationItemIndex: any) => {
        if (explanationItem.type === 'TikZ') {
          console.log(explanation);
          console.log('exp tikz -> ', explanation.data);
          totaltikZ.push({
            id:
              'tikzOutput-optionExplanation-' +
              explanationIndex +
              '-' +
              explanationItemIndex,
            data: explanationItem.data
          });
        }
      });
    });

    const gridinExplanations: any[] = this.gridinExplanations || [];
    console.log(gridinExplanations);
    gridinExplanations.forEach((explanation, explanationIndex) => {
      // explanation.forEach((explanationItem: any, explanationItemIndex: any) => {
      if (explanation.type === 'TikZ') {
        console.log(explanation);
        console.log('exp tikz -> ', explanation.data);
        totaltikZ.push({
          id: 'tikzOutput-freetextExplanation-' + explanationIndex,
          data: explanation.data
        });
      }
      // });
    });
    console.log(totaltikZ);
    if (totaltikZ.length > 0) {
      this.delayTikz(0, totaltikZ);
    }
  }

  delayTikz(index: number, totaltikZ: TikZType[]) {
    setTimeout(() => {
      console.log(index, totaltikZ[index]);
      new update(totaltikZ[index].data, totaltikZ[index].id);
      index++;
      if (index < totaltikZ.length) {
        this.delayTikz(index, totaltikZ);
      }
    }, 1000);
  }

  /* API requests */

  getSectionsForCourse(index: number) {
    this.globalApiService
      .getSectionsByTestTypeId(this.selectedCourses[index].courseId!)
      .subscribe(
        (response: any) => {
          console.log(response);
          const data = JSON.parse(response.data);
          console.log(data);
          const sections = data || [];
          this.selectedCourses[index].sections = sections;
          if (this.selectedCourses[index].topicId) {
            this.getTopicsAndSubTopics(index);
          }
        },
        (error: any) => {
          this.notifier.notify('error', 'Unable to fetch section types');
        }
      );
  }

  getTopicsAndSubTopics(index: number): void {
    const course: Course = this.selectedCourses[index];
    const sectionIndex: number = course.sections.findIndex((section) => {
      return course.sectionId === section.test_section_type_id;
    });
    this.globalApiService
      .getTopicsAndSubTopicsByTestSection(
        course.sections[sectionIndex].test_section_type_id
      )
      .subscribe(
        (response: any) => {
          console.log(response);
          const data: any = JSON.parse(response.data);
          course.topics = data.result;
          if (course.topicId !== null) {
            const topicIndex = course.topics.findIndex((topic) => {
              return topic.topic_id === course.topicId;
            });
            course.subTopics = course.topics[topicIndex].subtopics;
          }
        },
        (error: any) => {
          this.notifier.notify('error', 'Unable to fetch topics and subtopics');
        }
      );
  }
  getQuestionVideos() {
    this.globalApiService.getQuestionVideos(this.questionId!).subscribe({
      next: (res: any) => {
        console.log('FULL RESPONSE:', res);
        console.log(res);
        this.questionVideos = (res?.videos || [])
          .map((v: any, index: number) => ({
            ...v,
            uploadTime: v.createdOn
              ? new Date(v.createdOn + 'Z').toLocaleString()
              : new Date().toLocaleString(),
            order: v.order || index + 1
          }))
          .sort((a: any, b: any) => a.order - b.order);
      },
      error: (err) => {
        console.error(err);
      }
    });
  }

  getData() {
    const forkJoinItems: any[] = [
      this.globalApiService.getDifficultyLevels(),
      // this.globalApiService.getTopicsAndSubTopics(
      //   this.sectionId,
      //   this.courseId
      // ),
      this.globalApiService.getTestTypes()
    ];
    if (!this.isCreateQuestion) {
      forkJoinItems.push(this.globalApiService.getQuestions(this.questionId!));
    }
    forkJoin(forkJoinItems).subscribe((response: any[]) => {
      console.log(response);
      /* Question Data Response handling */
      if (!this.isCreateQuestion) {
        this.selectedTab = 3;
        this.questionDetails = response[2];
        const questionData = response[2].question.questionData || [];
        const listOfImages: string[] = [];
        questionData.forEach((question: any, questionIndex: number) => {
          question['hidden'] = questionIndex !== 0;
          if (question['type'] === 'Images') {
            question['images'] = JSON.parse(question['data']) || [];
            listOfImages.push(...question['images']);
            question['data'] = '';
          }
        });
        this.questionArray = questionData;
        this.tags = response[2].question.tags;
        console.log('tags', this.tags);
        if (this.questionDetails.question.questionType === 1) {
          const optionArray: any[] = [];
          const optionExplanations: any[] = [];
          response[2].choices.forEach((choice: any, index: number) => {
            const optionValue: any[] = choice.optionValue || [];
            optionValue.forEach((option, optionIndex) => {
              option['hidden'] = optionIndex !== 0;
              if (option['type'] === 'Images') {
                option['images'] = JSON.parse(option['data']) || [];
                listOfImages.push(...option['images']);
                option['data'] = '';
              }
            });
            const explanations: any[] = choice.explanation || [];
            explanations.forEach((explanation, explanationIndex) => {
              explanation['hidden'] = explanationIndex !== 0;
              if (explanation['type'] === 'Images') {
                explanation['images'] = JSON.parse(explanation['data']) || [];
                listOfImages.push(...explanation['images']);
                explanation['data'] = '';
              }
            });
            console.log(choice.optionValue, optionValue);
            console.log(choice.explanation, explanations);
            optionArray.push(optionValue);
            optionExplanations.push(explanations);
            if (choice.isAnswer) {
              this.defaultAnswer = index + 1;
            }
          });
          this.optionArray = optionArray;
          this.optionExplanations = optionExplanations;
        } else if (this.questionDetails.question.questionType === 2) {
          this.gridinAnswers = response[2].answers.posibilities.map(
            (answer: string, gridinIndex: number) => {
              return { data: answer, hidden: gridinIndex !== 0 };
            }
          );
          this.gridinExplanations = response[2].answers.explanation.map(
            (explanation: any, explanationIndex: number) => {
              explanation['hidden'] = explanationIndex !== 0;
              if (explanation['type'] === 'Images') {
                explanation['images'] = JSON.parse(explanation['data']) || [];
                listOfImages.push(...explanation['images']);
                explanation['data'] = '';
              }
              return explanation;
            }
          );
          console.log(this.gridinExplanations);
        }
        this.getImages(listOfImages);
        this.selectedCourses = this.questionDetails.questionTestTypes.map(
          (course: any, index: number) => {
            return <Course>{
              courseId: course.testTypeId,
              sectionId: course.testSectionId,
              topicId: course.topicId,
              subTopicId: course.subTopicId,
              difficultyLevel: course.difficultyLevel,
              questionCategory: course.questionCategory,
              hidden: index !== 0,
              sections: [],
              topics: [],
              subTopics: []
            };
          }
        );
        this.selectedQuestionType = response[2].question.questionType;
        this.selectedDisplayStyle = response[2].question.displayStyle;
        this.isTestQuestion = response[2].question.isTestQuestion;
        this.doesTikzExists();
        const course: Course = this.selectedCourses[0];
        this.questionBankService.setQuestionBankFilters({
          courseId: course.courseId,
          sectionId: course.sectionId,
          topicId: course.topicId,
          subTopicId: course.subTopicId,
          difficultyLevel: course.difficultyLevel,
          questionType: this.selectedQuestionType
        });
        setTimeout(() => {
          this.loadTikZ();
          setTimeout(() => {
            const margin = this.calculateMargin();
            document.getElementById('create-box')!.style.marginTop =
              margin['margin-top'];
          }, 1000);
        }, 500);
      } else {
        this.selectedQuestionType = this.questionBankFilter?.questionType || 1;
      }

      /* Difficulty Levels API */
      this.difficultyLevels = response[0];

      /* Courses API */
      this.courses = response[1];
      console.log(this.courses);
      if (!this.isCreateQuestion) {
        this.selectedCourses.forEach((course: Course, index: number) => {
          this.getSectionsForCourse(index);
        });
      } else if (this.selectedCourses.length > 0) {
        this.getSectionsForCourse(0);
      }
    });
  }

  getImages(listOfImages: string[]) {
    this.globalApiService.getImages(listOfImages).subscribe(
      (response: any) => {
        console.log(response);
        const data = response.data;
        if (data) {
          this.images = { ...this.images, ...data };
        }
        console.log(this.images);
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  saveQuestion(isCopy: boolean): void {
    console.log(this.questionArray, this.optionArray, this.gridinAnswers);
    if (!this.saveQuestionClicked) {
      this.saveQuestionClicked = true;
      let error: boolean = false,
        questionError: boolean = false,
        optionsError: boolean = false,
        gridinError: boolean = false,
        attachedToError: boolean = false;
      if (this.questionArray.length === 0) {
        error = true;
        questionError = true;
      }
      if (this.selectedQuestionType === 1) {
        for (let option of this.optionArray) {
          if (option.length === 0) {
            error = true;
            optionsError = true;
            break;
          } else {
            for (let optionItem of option) {
              if (optionItem.data === '' && optionItem.images.length === 0) {
                error = true;
                optionsError = true;
                break;
              }
            }
          }
        }
        if (this.defaultAnswer === null) {
          error = true;
          optionsError = true;
        }
      }
      if (this.selectedQuestionType === 2) {
        for (let answer of this.gridinAnswers) {
          console.log(answer);
          if (!answer.data) {
            error = true;
            break;
          }
        }
      }
      for (let question of this.questionArray) {
        if (question.data === '' && question.images.length === 0) {
          questionError = true;
          error = true;
          break;
        }
      }
      if (this.selectedCourses.length === 0) {
        error = true;
        attachedToError = true;
      } else {
        for (let course of this.selectedCourses) {
          if (
            course.courseId === null ||
            course.sectionId === null ||
            course.topicId === null ||
            course.subTopicId === null ||
            course.difficultyLevel === null
          ) {
            error = true;
            attachedToError = true;
            break;
          }
        }
      }
      this.errorExists = error;
      this.questionError = questionError;
      this.optionsError = optionsError;
      this.gridinError = gridinError;
      this.attachedToError = attachedToError;
      console.log(
        this.errorExists,
        this.questionError,
        this.optionsError,
        this.gridinError
      );
      if (!this.errorExists) {
        const saveQuestionData: any = {
          question: {
            questionData: this.questionArray.map((question) => {
              return {
                data:
                  question.type === 'Images'
                    ? JSON.stringify(question.images)
                    : question.data,
                type: question.type
              };
            }),
            tags: this.tags,
            questionType: this.selectedQuestionType,
            displayStyle: this.selectedDisplayStyle,
            status: this.status
          },
          questionTestTypes: this.selectedCourses.map((course: Course) => {
            return {
              testTypeId: course.courseId,
              testSectionId: course.sectionId,
              topicId: course.topicId,
              subTopicId: course.subTopicId,
              difficultyLevel: course.difficultyLevel,
              questionCategory: course.questionCategory
            };
          })
        };
        if (this.selectedQuestionType === 1) {
          saveQuestionData.choices = [];
          this.optionArray.forEach((option, index) => {
            const optionValue = option.map((value) => {
              return {
                data:
                  value.type === 'Images'
                    ? JSON.stringify(value.images)
                    : value.data,
                type: value.type
              };
            });
            const explanation = this.optionExplanations[index].map((value) => {
              return {
                data:
                  value.type === 'Images'
                    ? JSON.stringify(value.images)
                    : value.data,
                type: value.type
              };
            });
            const optionData: any = {
              optionValue,
              isAnswer: this.defaultAnswer === index + 1,
              explanation
            };
            if (
              !this.isCreateQuestion &&
              !isCopy &&
              this.questionDetails.choices[index]
            ) {
              optionData['optionId'] =
                this.questionDetails.choices[index].optionId;
            }
            saveQuestionData.choices.push(optionData);
          });
        } else {
          saveQuestionData.answers = {
            posibilities: this.gridinAnswers.map((gridin) => gridin.data),
            explanation: this.gridinExplanations.map((explanation) => {
              return {
                data:
                  explanation.type === 'Images'
                    ? JSON.stringify(explanation.images)
                    : explanation.data,
                type: explanation.type
              };
            })
          };
        }
        saveQuestionData.videos = this.questionVideos;
        console.log(saveQuestionData);
        (this.isCreateQuestion || isCopy
          ? this.globalApiService.saveQuestions(saveQuestionData)
          : this.globalApiService.updateQuestion(
              saveQuestionData,
              this.questionId!
            )
        ).subscribe(
          (response: any) => {
            console.log(response);
            this.saveQuestionClicked = false;
            this.notifier.notify('success', 'Successfully saved the question');
            const course = this.selectedCourses[0];
            this.questionBankService.setQuestionBankFilters({
              courseId: course.courseId,
              sectionId: course.sectionId,
              topicId: course.topicId,
              subTopicId: course.subTopicId,
              difficultyLevel: course.difficultyLevel,
              questionType: this.selectedQuestionType
            });
            this.router.navigate([this.returnTo]);
          },
          (error: any) => {
            console.log(error);
            this.saveQuestionClicked = false;
            this.notifier.notify('error', 'Unable to save the question');
          }
        );
      } else {
        this.saveQuestionClicked = false;
        this.notifier.notify('error', 'Please clear all errors');
      }
    }
  }

  calculateMargin() {
    const previewBox: HTMLElement | null =
      document.getElementById('preview-box');
    const height = previewBox?.offsetHeight;
    return { 'margin-top': `${height! - 15}px` };
  }

  getCourseName(course: Course): string {
    if (course.courseId) {
      const courseIndex = this.courses.findIndex((courseItem) => {
        return courseItem.testTypeId === course.courseId;
      });
      return this.courses[courseIndex].testTypeName;
    } else {
      return 'No Course Selected';
    }
  }

  uploadImage(event: any, index: number, array: any[]) {
    const file = event.event.target.files[0];
    if (file.size > 1000000) {
      this.notifier.notify('error', 'File size exceeds 1MB.');
      event.fileSelector.value = '';
    } else if (!file.type.startsWith('image')) {
      this.notifier.notify('error', 'Invalid file format');
      event.fileSelector.value = '';
    } else {
      const formData = new FormData();
      formData.append('to', 'questionBank');
      formData.append('files', file);
      this.globalApiService.uploadImage(formData).subscribe(
        (response: any) => {
          console.log(response, array, index, array[index]);
          const data = response.data;
          if (data) {
            array[index].images.push(Object.keys(data)[0]);
            this.images = { ...this.images, ...data };
          }
          event.fileSelector.value = '';
        },
        (error: any) => {
          console.log(error);
          this.notifier.notify('error', 'Unable to upload file');
          event.fileSelector.value = '';
        }
      );
    }
  }
  onFolderSelected(event: any) {
    const files: FileList = event.target.files;
    this.selectedVideos = [];

    for (let i = 0; i < files.length; i++) {
      if (files[i].type.startsWith('video/')) {
        this.selectedVideos.push(files[i]);
      }
    }
    console.log('Selected videos:', this.selectedVideos);
  }
  uploadVideos() {
    if (!this.selectedVideos.length) {
      this.notifier.notify('error', 'Please select videos first');
      return;
    }
    if (!this.questionId) {
      this.notifier.notify('error', 'Please save the question first');
      return;
    }
    const formData = new FormData();
    this.selectedVideos.forEach((file) => {
      formData.append('files', file);
    });
    this.isUploading = true;
    this.uploadProgress = 0;

    this.globalApiService
      .uploadQuestionVideos(this.questionId, formData)
      .subscribe(
        (event: any) => {
          if (event.type === 1 && event.total) {
            this.uploadProgress = Math.round(
              (100 * event.loaded) / event.total
            );
          } else if (event.body) {
            console.log('Upload response:', event.body);

            this.notifier.notify('success', 'Videos uploaded successfully');
            this.isUploading = false;

            this.getQuestionVideos();
          }
        },
        (error) => {
          console.error(error);
          this.notifier.notify('error', 'Unable to upload videos');
          this.isUploading = false;
        }
      );
  }
  onVideoFolderSelected(event: any) {
    const files: FileList = event.target.files;
    this.selectedVideos = [];

    for (let i = 0; i < files.length; i++) {
      if (files[i].type.startsWith('video/')) {
        this.selectedVideos.push(files[i]);
      }
    }

    console.log('Selected videos:', this.selectedVideos);
  }
  playVideo(video: any, index: number) {
    this.selectedVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      video.iframeUrl
    );
    this.selectedVideoIndex = index;
  }
  closeVideo() {
    this.selectedVideoIndex = null;
    this.selectedVideoUrl = null as any;
  }
  toggleVideoStatus(video: any, event: any) {
    const isActive = event.target.checked;
    const videoId = video.videoId;
    console.log('SENDING:', videoId, isActive);
    this.globalApiService
      .updateVideoStatus(videoId, isActive)
      .subscribe((res) => {
        console.log('RESPONSE:', res);
      });
  }
  drop(event: CdkDragDrop<QuestionVideo[]>) {
    moveItemInArray(
      this.questionVideos,
      event.previousIndex,
      event.currentIndex
    );
    const payload = this.questionVideos.map((video, index) => ({
      videoId: video.videoId,
      displayOrder: index + 1
    }));
    this.globalApiService.updateVideoDisplayOrderBatch(payload).subscribe({
      next: (res) => {
        console.log('Video display order updated successfully', res);
        this.notifier.notify('success', 'Video order updated');
      },
      error: (err) => {
        console.error('Error updating video order', err);
        this.notifier.notify('error', 'Unable to update video order');
      }
    });
  }
  trackByVideo(index: number, item: any) {
    return item.id || item.videoId || index;
  }

  // ** modifying ngIf's and ngFor's for diferrent question types
  // getExplanationArray(questionType: number | null): any {
  //   let explanationArray: MultiData[][] | MultiData[] =
  //     questionType === 1 ? this.optionExplanations : this.gridinExplanations;
  //   console.log(this.optionExplanations);
  //   return explanationArray;
  // }

  /* Destroying the subscriptions */

  print(yo: string) {
    console.log('yo is -----> ', yo);
  }

  ngOnDestroy(): void {
    if (this.paramSubscription) {
      this.paramSubscription.unsubscribe();
    }
    this.questionBankFilterSubscription.unsubscribe();
  }
}
